import {DegreeTypeOrderField, PublicMentorField} from "../../../../../types/generated";

export function hasMentorFieldData(
    field: string,
    mentor: PublicMentorField,
    isDegreeTypesEnabled: boolean,
    degreeTypeOrder: DegreeTypeOrderField[],
): boolean {
    switch (field) {
        case "country":
            return Boolean(mentor?.country);
        case "year":
            return Boolean(mentor?.year);
        case "degrees":
            if (!isDegreeTypesEnabled) return false;

            // eslint-disable-next-line no-case-declarations
            const degreesToShow = mentor?.degrees?.filter((degree) =>
                degreeTypeOrder.some((order) => order.type === degree.degreeType),
            );

            return Array.isArray(degreesToShow) && degreesToShow.length > 0;
        case "languages":
            return Array.isArray(mentor?.languages) && mentor?.languages?.length > 0;
        case "degree":
            return Boolean(mentor?.degree?.name) && !isDegreeTypesEnabled;
        case "favouriteModules":
            return Array.isArray(mentor?.favouriteModules) && mentor?.favouriteModules?.length > 0;
        case "pastQualification":
            return Boolean(mentor?.pastQualification);
        case "interests":
            return Array.isArray(mentor?.interests) && mentor?.interests?.length > 0;
        case "societies":
            return Array.isArray(mentor?.societies) && mentor?.societies?.length > 0;
        case "bio":
            return Boolean(mentor?.bio?.length) || Boolean(mentor?.shortBio?.length);
        default: {
            const customField = mentor?.customAttributes?.find(
                (customAttribute) => customAttribute?.attribute?.id === field,
            );
            return Boolean(customField?.option?.value);
        }
    }
}
